import Swal from 'sweetalert2';

export const conversionRates = {
    pesos: 1,
    miles: 1000,
    millones: 1000000,
    milesMillones: 1000000000,
};

export function computoUnidad(
    event: any,
    field: string,
    product: any,
    currentCurrency: string
): void {
    const { cantidadUnidadVendida, precioVenta, valorUnitario } = product;
    const conversionRate = conversionRates[currentCurrency];

    if (field === 'cantidadUnidadVendida' || field === 'precioVenta') {
        if (cantidadUnidadVendida === 0 && precioVenta > 0) {
            product.valorUnitario = null;
            Swal.fire(
                'Error coherencia de datos',
                'La cantidad vendida no puede ser 0 si el precio de venta es mayor a 0',
                'error'
            );
            return;
        }

        if (cantidadUnidadVendida > 0 && precioVenta === 0) {
            product.valorUnitario = null;
            Swal.fire(
                'Error coherencia de datos',
                'El precio de venta no puede ser 0 si la cantidad vendida es mayor a 0',
                'error'
            );
            return;
        }

        if (cantidadUnidadVendida == 0 && precioVenta == 0) {
            product.valorUnitario = 0;
        }

        if (
            cantidadUnidadVendida != null &&
            precioVenta != null &&
            cantidadUnidadVendida > 0
        ) {
            const convertedPrecioVenta = precioVenta * conversionRate;
            product.valorUnitario = parseFloat(
                (convertedPrecioVenta / cantidadUnidadVendida).toFixed(1)
            );
        }
    }

    if (field === 'valorUnitario') {
        if (cantidadUnidadVendida != null && valorUnitario != null) {
            product.precioVenta = parseFloat(
                (
                    (cantidadUnidadVendida * valorUnitario) /
                    conversionRate
                ).toFixed(1)
            );
        } else if (precioVenta != null && valorUnitario != null) {
            const convertedPrecioVenta = precioVenta * conversionRate;
            product.cantidadUnidadVendida = parseFloat(
                (convertedPrecioVenta / valorUnitario).toFixed(1)
            );
        }
    }
}

export function validarNumeros(
    inputValue: string,
    tipoMoneda = 'pesos'
): string {
    const tieneComa: boolean = /,/.test(inputValue);

    let limiteNumeros: number;

    if (tipoMoneda === 'millones') {
        limiteNumeros = tieneComa ? 9 : 8;
    } else if (tipoMoneda === 'miles') {
        limiteNumeros = tieneComa ? 12 : 11;
    } else if (tipoMoneda === 'milesMillones') {
        limiteNumeros = tieneComa ? 6 : 5;
    } else if (tipoMoneda === 'pesos') {
        limiteNumeros = tieneComa ? 15 : 14;
    }

    const numerosSolo = inputValue.replace(/\D/g, '');
    if (numerosSolo.length > limiteNumeros) {
        Swal.fire(
            'El precio de venta debe ser menor a 100 billones de pesos',
            'Por favor valide y vuelva a intentar',
            'warning'
        );
        return '';
    }
    return inputValue;
}
